// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"070df4c7","691":"7271c4b5"}[chunkId] + ".chunk.js";
};